import * as React from 'react'
import { FC, useCallback, useMemo, useState } from 'react'
import { SideDrawerForm } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { CustomSettingsList } from './CustomSettingsList'
import { ICustomFieldFormSetting } from '@user/store/entityFormSettings'
import { settingsToInput } from './hooks/mapper'
import {
  reorderCustomFieldSettings,
  setCustomFieldsSettingsOrder,
} from '@user/store/customFieldSettings'
import { ENTITY_TYPES } from '@sales-center/common'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { getStyles } from './styling'
import { useTheme } from '@mui/material/styles'

interface Props {
  onClose: () => void
  settings: ICustomFieldFormSetting[]
  entityType: ENTITY_TYPES
}

export const ReOrderSettingsForm: FC<Props> = (props) => {
  const { onClose, settings, entityType } = props

  const dispatch = useAppDispatch()
  const [reorderedSettings, reorderSettings] = useState([...settings])

  const input = useMemo(
    () =>
      settingsToInput(
        reorderedSettings,
        entityType === ENTITY_TYPES.Lead ? 0 : 1,
      ),
    [entityType, reorderedSettings],
  )

  const onSave = useCallback(async () => {
    await dispatch(
      setCustomFieldsSettingsOrder(
        reorderedSettings.map((field) => ({
          id: field.customFieldId,
          order: field.order,
        })),
      ),
    )
    await dispatch(reorderCustomFieldSettings(input))
    onClose()
  }, [dispatch, reorderedSettings, input, onClose])
  const styles = getStyles(useTheme())
  return (
    <SideDrawerForm onSave={onSave} onCancel={onClose} primaryBtnLabel="Apply">
      <Box
        display="flex"
        justifyContent="space-between"
        mr={1.5}
        ml={2}
        mt={2.7}
        mb={2.7}
      >
        <Box>
          <Typography variant="body1" sx={styles.formInfoLabel}>
            Re-Order Columns to be Displayed
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" sx={styles.subFormInfoLabel}>
            (Drag to reorder)
          </Typography>
        </Box>
      </Box>
      <CustomSettingsList
        settings={reorderedSettings}
        updateSettings={reorderSettings}
      />
    </SideDrawerForm>
  )
}
ReOrderSettingsForm.displayName = 'ReOrderSettingsForm'
